import React from "react";

interface CaptionProps {
    text: string;
    fontSize?: string;
}

const InstagramCaption: React.FC<CaptionProps> = ({ text, fontSize="14px" }) => {
    const formatText = (text: string) => {
        return text
            .split("\n")
            .map((line, index) => (
                <span key={index}>
                    {line.split(" ").map((word, idx) => {
                        if (word.startsWith("#")) {
                            return (
                                <a
                                    key={idx}
                                    href={`https://www.instagram.com/explore/tags/${word.substring(1)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500"
                                >
                                    {word}{" "}
                                </a>
                            );
                        } else if (word.startsWith("@")) {
                            return (
                                <a
                                    key={idx}
                                    href={`https://www.instagram.com/${word.substring(1)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500"
                                >
                                    {word}{" "}
                                </a>
                            );
                        }
                        return word + " ";
                    })}
                    <br />
                </span>
            ));
    };

    return <p className="post-caption" style={{fontSize}}>{formatText(text)}</p>;
};

export default InstagramCaption;